<script setup>

const modelValue = defineModel()

/*
 
    // 3672 images> части
    // 3292 plan> план
    // 510 photos> общ

    /// Карточке обьекта - [3672, 510] / [3672, 510] / [3292, 3672, 510] / [510, 3292, 3672]
    /// Странице обьекта - 

*/


const photos = computed(() => {

    let o = {
        first: [

        ],
        second: [],
        last: [],
        old: []
    }

    // let list_images = ( modelValue.value.images.length > 0 ) ? modelValue.value.images : false
    // let list_plan = ( modelValue.value.plan.length > 0 ) ? modelValue.value.plan : false
    // let list_photos = ( modelValue.value.photos.length > 0 ) ? modelValue.value.photos : false

    // let list_images_len = modelValue.value.images.length
    // let list_plan_len = modelValue.value.plan.length
    // let list_photos_len = modelValue.value.photos.length

    // // Наполнение первых двух фото
    // if( list_images_len > 0 ) o.first.push( list_images[0] )
    // if( list_images_len > 1 ) o.first.push( list_images[1] )
    // if( o.first.length == 0 && list_photos_len > 0 ) o.first.push( list_photos[0] )
    // if( o.first.length == 0 && list_photos_len > 1 ) o.first.push( list_photos[1] )
    // if( o.first.length == 0 && list_plan_len > 0 ) o.first.push( list_plan[0] )
    // if( o.first.length == 0 && list_plan_len > 1 ) o.first.push( list_plan[1] )

    // // Наполнение третьего фото
    // if( list_plan_len > 0 ) o.second.push( list_plan[0] )
    // if( o.first.length == 0 ?? list_plan_len > 1 ) o.second.push( list_plan[1] )


    // if( list_plan_len > 0 ) o.second.push( list_plan[0] )
    // if( list_photos_len > 0 ) o.last.push( list_plan[0] )


    // {

    //     if( o.second.length == 0 && list_images.length > 1 ) o.second.push( list_images[1] )
    //     if( o.last.length == 0 ) o.last.push( list_images[1] )
    //     if( list_photos && list_photos.length > 0 ){
    //         o.last.push( list_plan[0] )
    //     }
    // }

})


import { Swiper, SwiperSlide } from "swiper/vue";
import { Fancybox } from '@fancyapps/ui';
import { FreeMode, Navigation, Thumbs } from "swiper/modules";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "swiper/swiper-bundle.css";

const modules = ref([FreeMode, Navigation, Thumbs]);

const mainSwiper = ref(null);
const activeIndex = ref(0);
const limitImgIndex = ref(5);

const onSwiper = (swiper) => {
    mainSwiper.value = swiper;
};

const goToSlide = (index) => {
    if (mainSwiper.value) {
        mainSwiper.value.slideTo(index);
    }
};

const onSlideChange = () => {
    if (mainSwiper.value) {
        activeIndex.value = mainSwiper.value.activeIndex;
    }
};





const combinedImages = ref([])
const generatePhotos = () => {

    const result = []

    const usedUrls = new Set()
    const addUnique = (url) => {
        if (url && !usedUrls.has(url)) {
            result.push(url)
            usedUrls.add(url)
        }
    }

    if (!modelValue.value.images) modelValue.value.images = []
    if (!modelValue.value.plan) modelValue.value.plan = []
    if (!modelValue.value.photos) modelValue.value.photos = []

    if (modelValue.value.images.length > 0) {
        addUnique(modelValue.value.images[0])

        if (modelValue.value.images[1]) {
            addUnique(modelValue.value.images[1])
        } else if (modelValue.value.photos.length > 0) {
            addUnique(modelValue.value.photos[0])
        }

    } else if (modelValue.value.photos.length > 0) {
        addUnique(modelValue.value.photos[0])

        if (modelValue.value.photos[1]) {
            addUnique(modelValue.value.photos[1])
        }

    }

    if (modelValue.value.plan.length > 0) {
        addUnique(modelValue.value.plan[0])
    }

    if (modelValue.value.photos.length > 2) {
        addUnique(modelValue.value.photos[2])
    }

    if (modelValue.value.images.length > 2) {
        modelValue.value.images.slice(2).forEach(addUnique)
    }

    if (modelValue.value.plan.length > 1) {
        modelValue.value.plan.slice(1).forEach(addUnique)
    }

    if (modelValue.value.photos.length > 3) {
        modelValue.value.photos.slice(3).forEach(addUnique)
    }

    combinedImages.value = result

    return true

}

onMounted(() => {
    if(window.innerWidth <= 768){
        limitImgIndex.value = 4;
    }

    Fancybox.bind("[data-fancybox='gallery']", {
        afterClose: () => {
            if (mainSwiper.value) {
                mainSwiper.value.update();
            }
        },
    });

    setTimeout(() => {
        generatePhotos()
    }, 1000);

});

</script>
<template>
    
        <div class="items-stretch w-full h-300 sm:h-[600px] gap-3 flex">
            <client-only>
                <div class="flex flex-col gap-1" :class="{'justify-start': combinedImages.length <= limitImgIndex, 'justify-between': combinedImages.length > limitImgIndex}">
                    <div v-for="(thumb, index) in combinedImages" :key="index" @click="goToSlide(index)"
                        :class="{'border-2 border-blue-400': index === activeIndex, 'hidden': index > limitImgIndex, 'inline-block': index <= limitImgIndex }"
                        class="rounded-xl  cursor-pointer flex relative">
                        <img :src="thumb" alt="image" class="rounded-xl" />
                        <div v-if="index === limitImgIndex && combinedImages.length > (limitImgIndex + 1)"
                            class="absolute rounded-lg inset-0 bg-black bg-opacity-50 flex items-center justify-center text-white text-xl font-semibold">
                            +{{ combinedImages.length - (limitImgIndex + 1) }}
                        </div>
                    </div>
                </div>
            </client-only>

            <client-only>
                <div class="w-[85%]">
                    <swiper ref="mainSwiper" :spaceBetween="10" :navigation="true" :modules="[Navigation, Thumbs]"
                        class="mySwiper2" @swiper="onSwiper" @slideChange="onSlideChange">
                        <swiper-slide v-for="(image_src, index) in combinedImages" :key="index">
                            <a :href="image_src.replace('resized200x200', 'resized800x600')" data-fancybox="gallery"
                                class="inline-block h-full">
                                <img :src="image_src.replace('resized200x200', 'resized800x600')" alt="image"
                                    class="rounded-xl cursor-pointer h-full object-cover" />
                            </a>
                        </swiper-slide>
                    </swiper>
                </div>
            </client-only>
        </div>
        
        
        
    
</template>

<style scoped>
.swiper {
    height: 100%;
}
.swiper-slide{
    @apply flex justify-center items-center;
}
/* Change the color of the next arrow */
.mySwiper2 > .swiper-button-next::after{
    content: 'precustom' !important;
    width: 30px;
    background-image: url("/public/img/icons/carousel/next.svg");
    background-repeat: no-repeat;
    background-position: center center;
}
/* Change the color of the previous arrow */
.mySwiper2 > .swiper-button-prev::after{
    content: 'precustom' !important;
    width: 30px;
    background-image: url("/public/img/icons/carousel/prev.svg");
    background-repeat: no-repeat;
    background-position: center center;
}

</style>